// src/components/ActionBar.jsx
import React from 'react';

const ActionBar = ({ batchDownload, batchDelete, fullAnalysis }) => {
  return (
    <div className="actions-bar">
      <button onClick={batchDownload} className="action-button">
        Download Selected
      </button>
      <button onClick={batchDelete} className="action-button">
        Delete Selected
      </button>
      <button onClick={fullAnalysis} className="action-button">
        Analysis
      </button>
    </div>
  );
};

export default ActionBar;